<div class="ad-card-container mb-4" (click)="openAd()">
  <!-- Image -->
  <div class="image-container">
    <img class="ad-img" *ngIf="!isImageError" [appImageSrc]="ad?.media" (error)="onImageError($event)" />

    <!-- Add a placeholder or empty state -->
    <div *ngIf="isImageError" class="empty-state text-center py-5">
      <div class="empty-state-content">
        <i class="fe fe-image fa-3x mb-3 text-muted"></i>
        <h5 class="text-muted">Image Not Available</h5>
      </div>
    </div>
    <label *ngIf="isAll" class="typeBadge">{{ ad.status | adStatusPipe }}</label>
    <button *hasPermission="'ads.delete'" type="button" class="delete-ad-btn" title="Delete ad"
      (click)="removeAd($event)">
      <i class="fe fe-trash-2" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Textual Details -->
  <div class="details">
    <span *ngIf="ad.companyName != null" class="companyName">BY {{ ad.companyName }}</span>
    <span class="title">
      {{ ad.title }}
      <span class="category">{{ (ad.category | category | async) }}</span>
    </span>
    <span class="description">{{ ad.description }}</span>

    <!-- <span>{{ ad.creationDate | date: 'longDate' }}</span> -->

    <div class="footer" *ngIf="ad.companyName != null">
      <a *ngIf="ad?.link" [href]="ad.link" target="_blank" class="btn link-btn" (click)="$event.stopPropagation()">
        View Link
      </a>
      <ng-container *ngIf="!ad?.link">
        <button *hasPermission="'ads.edit'" class="btn link-btn me-2" (click)="openModal(AddLinkModal, $event)">
          Add Link
        </button>
      </ng-container>
    </div>

    <div class="footer" *ngIf="ad.companyName == null">
      <button class="btn link-btn " routerLink="/ads">
        View Ads
      </button>
    </div>
  </div>
</div>


<!-- Modal Template for Link -->
<ng-template #AddLinkModal let-modal>
  <div class="modal-centered" style="width: 100%;">
    <div class="modal-content" style="min-height: 200px;">
      <div class="modal-header">
        <h5 class="modal-title">{{ad?.link == null ? "Add" : "Change"}} Link</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" [formGroup]="linkForm">

        <input type="text" class="form-control text-black" formControlName="link" placeholder="Enter Link" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-o" (click)="modal.dismiss('Cross click')">Cancel</button>
        <button type="button" class="btn btn-primary" [disabled]="linkForm.value.link == '' || isSaving"
          (click)="addLink()">
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!isSaving">Save</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
